import styled from '@emotion/styled';
import rem from '../../../utils/rem/rem';

export const EditCell = styled.span`
  display: flex;
  align-items: center;
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: ${rem(14)};
`;

export const IconButton = styled.button`
  border: none;
  background-color: transparent;
  margin-left: 4px;
`;

export const CellTextWrapper = styled.span`
  width: ${rem(75)}
`;